import { isString } from 'lodash';

export const getSafeInteger = (
  value: string | number | (string | null)[] | null | undefined,
  fallback: number
): number => {
  if (value === null || value === undefined) {
    return fallback;
  }

  if (Array.isArray(value)) {
    const firstValue = value[0];

    return getSafeInteger(firstValue, fallback);
  }

  const numberValue = isString(value) ? Number(value) : value;

  return Number.isSafeInteger(numberValue) ? numberValue : fallback;
};
